// Viewport
export const SET_VIEWPORT = 'SET_VIEWPORT';
export const SET_PAGE_VISIBILITY = 'SET_PAGE_VISIBILITY';

// Project data

// Project state
export const TOGGLE_PROJECT_STATE = 'TOGGLE_PROJECT_STATE';
